import { createMuiTheme } from '@material-ui/core';

const plTheme = createMuiTheme({
  palette: {
    text: {
      primary: '#171F46',
      secondary: '#161e458a',
    },
  },
  zIndex: {
    drawer: 1200,
  },
  spacing: 4,
  typography: {
    fontFamily: ['Rubik', 'sans-serif', 'Mulish'].join(','),
    h1: {
      fontSize: '32px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '40px',
      letterSpacing: '0em',
      color: '#171F46'
    },
    h2: {
      fontSize: '24px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '32px',
      letterSpacing: '0em',
      color: '#171F46'
    },
    h3: {
      fontSize: '20px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '32px',
      letterSpacing: '0em',
      color: '#171F46'
    },
    h4: {
      fontSize: '18px',
      fontWeight: 400,
      fontStyle: 'normal',
      lineHeight: '24px',
      letterSpacing: '0em',
      color: '#171F46'
    },
    h5: {
      fontSize: '16px',
      fontWeight: 300,
      fontStyle: 'normal',
      lineHeight: '24px',
      letterSpacing: '0em',
      color: '#171F46'
    },
    h6: {
      fontSize: '12px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '16px',
      letterSpacing: '0.01em',
      color: '#171F46'
    },
    subtitle1: {
      fontSize: '14px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '24px',
      color: '#171F46'
    },
    subtitle2: {
      fontSize: '18px',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: '24px',
      color: '#171F46'
    },
    caption: {
      fontSize: '8px',
      fontWeight: 300,
      fontStyle: 'normal',
      lineHeight: '9.48px',
      letterSpacing: '-0.125714px',
      color: '#171F46'
    },
    body1: {
      fontSize: '18px',
      fontWeight: 300,
      fontStyle: 'normal',
      lineHeight: '16px',
      letterSpacing: '0.03em',
      color: '#171F46'
    },
    body2: {
      fontFamily: 'Mulish',
      fontSize: '39px',
      fontWeight: 700,
      fontStyle: 'normal',
      lineHeight: '48.95px',
      letterSpacing: '0.04px',
      color: '#171F46'
    },
    button: {
      fontSize: '19px',
      fontWeight: 700,
      fontStyle: 'normal',
      lineHeight: '22.27px',
      letterSpacing: '-0.125714px',
      alignContent: 'center',
      color: '#171F46'
    },
  },
  overrides: {
    MuiButton: {
      root: {
        height: '46px',
        fontSize: '19px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '22.27px',
        letterSpacing: '-0.125714px',
        alignContent: 'center',
      },
      containedPrimary: {
        backgroundColor: '#0B69FF',
      },
      outlined: {
        backgroundColor: 'white',
      },
    },
  },
});
export { plTheme };

export interface ColorMap {
  [name: string]: string;
}

export const COLORS: ColorMap = {
  TEXT_LOW_EMPHASIS: '#7E858E',
  TEXT_HIGH_EMPHASIS: '#171F46',
  BORDER_PRIMARY: '#D7DFE9',
  ALPHA_BACKGROUND_COLOR: 'rgba(215, 223, 233, 0.4)',
  BETA_BACKGROUND_COLOR: '#FBFBFB',
  PL_PRIMARY: '#366FF5',
  GAMMA_WHITE: '#fff',
  GAMMA_BLACK: '#000',
  TURQOISE: '#5CC0C9',
  PEOPLELENS_PRIMARY: '#366FF5',
  GENERAL_DARK_BLUE_32: '#B5B7C4',
  GENERAL_TREVA_PURPLE: '#6B38FB',
  GENERAL_BLACK: '#000000',
  GENERAL_CHART_GREEN: '#61DDAA',
  PORTFOLIO: '#FF0B37',
  GENERAL_CHART_2: '#458FFF',
  GENERAL_CHART_1: '#65789B',
  QUOTA: '#990300',
  GENERAL_WHITE: '#FFFFFF',
  GENERAL_DARK_BLUE: '#171F46',
  GENERAL_CHART_5: '#D7E6FF',
  GENERAL_CHART_3: '#8EBBFF',
  GENERAL_CHART_4: '#68A2FF',
  GENERAL_CHART_BUBBLE_5: '#B0FF94',
  GENERAL_CHART_BUBBLE_1: '#FB6262',
  GENERAL_CHART_BUBBLE_4: '#DDFFD1',
  GENERAL_CHART_BUBBLE_2: '#FFA4A4',
  GENERAL_CHART_BUBBLE_7: '#41E306',
  GENERAL_CHART_BUBBLE_6: 'RGBA(123, 255, 75, 0.9)',
  GENERAL_CHART_BUBBLE_8_1: '#47A524',
  GENERAL_CHART_BUBBLE_8_2: '#3BD403',
  GENERAL_CHART_BUBBLE_9: '#3F8825',
  GENERAL_CHART_BUBBLE_10: '#1D6B01',
  GENERAL_CHART_BUBBLE_11: '#165400',
  MAIN_BLUE_DEFAULT: '#0B69FF',
  MAIN_BLUE_PRESSED: '#0055DC',
  MAIN_BLUE_HOVER: 'RGBA(0, 88, 227, 0.3)',
  MAIN_HOVER_LIGHT: 'RGBA(11, 105, 255, 0.1)',
  MAIN_HUE_2: '#5B8FF9',
  MAIN_HUE_3: '#0058E3',
  MAIN_HUE_4: '#0B69FF',
  GREY_100: '#7E858E',
  GREY_60: 'RGBA(126, 133, 142, 0.6)',
  GREY_40: 'RGBA(126, 133, 142, 0.4)',
  GREY_4: 'RGBA(126, 133, 142, 0.13)',
  GREY_BACKGROUND: '#FBFBFB',
  GREY_TEXT_DARK: 'RGBA(0, 0, 0, 0.54)',
  LIGHT_GREY_100: 'RGBA(215, 223, 233, 0.4)',
  GREY_TEXT_DARKER: '#4B4D52',
  LIGHT_GREY_40: 'RGBA(215, 223, 233, 0.4)',
  LIGHT_GREY_50: 'RGBA(215, 223, 233, 0.5)',
  LIGHT_GREY_20: 'RGBA(215, 223, 233, 0.2)',
  LIGHT_GREY_24_HOVER: 'RGBA(215, 223, 233, 0.07)',
  ERROR_DEFAULT: '#FF0B37',
  BLUE_10: 'RGBA(11, 105, 255, 0.1)',
  ERROR_HOVER: '#EF0D36',
  ERROR_PRESSED: '#D7042A',
  ERROR_BACKGROUND: 'RGBA(255, 11, 55, 0.05)',
  SUCCESS_DEFAULT: '#2DCA73',
  SUCCESS_HOVER: '#26BF6A',
  SUCCESS_PRESSED: '#1DB05F',
  WARNING_DEFAULT: '#FFB800',
  SUCCESS_BACKGROUND: '#F3FFF8',
  WARNING_HOVER: '#F2AE00',
  WARNING_PRESSED: '#EAA800',
  WARNING_BACKGROUND: '#FFF8E6',
  TIMELINES_TEAL: '#B3F4E1',
  TIMELINES_BLUE: '#A4E3FE',
  TIMELINES_ORANGE: '#FFC28A',
  TIMELINES_PURPLE: '#C3AEFF',
  TIMELINES_PINK: '#FF9DE4',
  TIMELINES_RED: '#FF9D9D',
  TIMELINES_YELLOW: '#FFD89D',
  TIMELINES_GOLDEN: '#DDC196',
  TIMELINES_GREEN: '#A9ECA3',
  AVATARS_YELLOW_1: '#FFF1BB',
  TIMELINES_LAVANDER: '#AFC1FF',
  AVATARS_YELLOW_2: '#CA9F00',
  AVATARS_ORANGE_1: '#FFDCBB',
  AVATARS_ORANGE_2: '#D98304',
  AVATARS_PURPLE_1: '#D5BBFF',
  AVATARS_PURPLE_2: '#4D00CA',
  AVATARS_TEAL_2: '#00B2CA',
  AVATARS_BLUE_2: '#0051CA',
  AVATARS_BLUE_1: '#B0CDFA',
  AVATARS_RED_2: '#F13838',
  AVATARS_RED_1: '#FFBBD3',
  AVATARS_TEAL_1: '#B3F4E1',
  AVATARS_1: '#EEDDDD',
  AVATARS_2: '#D7DFE9',
  AVATARS_3: 'RGBA(255, 11, 55, 0.1)',
  TIMELINE_LIGHT_PINK: '#FAF2F8',
  TERTIARY_COLOR_ORANGE: '#FE9E02',
  TIMELINE_LIGHTIPURPLE: '#F0EBFF',
  BOX_SHADOW_CARDS: 'RGBA(126, 133, 142, 0.3)',
  BARGRAPH_LABEL: '#8D9AA9',
  ARROW_PRIMARY_COLOR: 'RGBA(255, 0, 0, 1)',
  TEAM_CARD_COLOR: '#F2F2F2',
  GREY_SPAN_COLOR: 'rgba(207, 220, 238, 0.33)',
  PINK_FEMALE_INDICATOR: '#FFA7D1',
  BLUE_MALE_INDICATOR: '#2E6FF2',
  NEUTRAL_INDICATOR: '#CBD2FF',
  LEARNER_BAR_LABEL: '#979797',
  WIDGET_TITLE: '#979797',
  HOMEPAGE_BACKGROUND: 'rgba(246, 246, 246, 1)',
  SPIDER_CHART_BACKGROUND: 'rgba(54, 111, 245, 0.24)',
  BATTLECARD_BOX_SHADOW: '#EDEEEF',
  BATTLECARD_DIVIDER_COLOR: '#F7F7F7',
  REPORTS_BOX_SHADOW: 'RGBA(126, 133, 142, 0.12)',
  REPCOMPARISONHEADINGCOLOR: '#1E1F20',
  REPORTPAGE6BACKGROUNDCOLOR: '#F6F7FA',
};
